import { render } from "./print-menu.vue?vue&type=template&id=b484f1fa"
import script from "./print-menu.vue?vue&type=script&lang=js"
export * from "./print-menu.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__